<template>
  <v-container id="dashboard" fluid tag="section">
    <v-row>
      <v-col cols="12">
        <div class="font-weight-light mt-1" style="font-size: 25px">
          Accesos Rápidos
        </div>
      </v-col>
      <v-col sm="12" md="4">
        <base-material-card color="transparent" image :hover-reveal="tienePermiso('M_jugadores')">
          <template v-slot:image>
            <router-link v-if="$can('M_jugadores')" to="ver/jugadores">
              <v-img :src="require(`@/assets/${'jugadores.jpg'}`)" />
            </router-link>
            <v-img v-else :src="require(`@/assets/${'jugadores.jpg'}`)" />
          </template>
          <v-card-title class="justify-center font-weight-light">
            Jugadores
          </v-card-title>
        </base-material-card>
      </v-col>

      <v-col sm="12" md="4">
        <base-material-card color="transparent" image :hover-reveal="tienePermiso('M_scouting')">
          <template v-slot:image>
            <router-link v-if="$can('M_scouting')" to="/ver/scouting">
              <v-img :src="require(`@/assets/${'scouting.jpg'}`)" />
            </router-link>
            <v-img v-else :src="require(`@/assets/${'scouting.jpg'}`)" />
          </template>
          <v-card-title class="justify-center font-weight-light">
            Scouting
          </v-card-title>
        </base-material-card>
      </v-col>

      <v-col sm="12" md="4">
        <base-material-card color="transparent" image :hover-reveal="tienePermiso('M_legales')">
          <template v-slot:image>
            <router-link v-if="$can('M_legales')" to="/ver/legales/litigios">
              <v-img :src="require(`@/assets/${'legales.jpg'}`)" />
            </router-link>
            <v-img v-else :src="require(`@/assets/${'legales.jpg'}`)" />
          </template>
          <v-card-title class="justify-center font-weight-light">
            Legales
          </v-card-title>
        </base-material-card>
      </v-col>
      <v-col sm="12" md="4">
        <base-material-card color="transparent" image :hover-reveal="tienePermiso('M_informes')">
          <template v-slot:image>
            <router-link v-if="$can('M_informes')" to="/ver/informes">
              <v-img :src="require(`@/assets/${'informes.jpg'}`)" />
            </router-link>
            <v-img v-else :src="require(`@/assets/${'informes.jpg'}`)" />
          </template>
          <v-card-title class="justify-center font-weight-light">
            Informes
          </v-card-title>
        </base-material-card>
      </v-col>

      <v-col sm="12" md="4">
        <base-material-card color="transparent" image hover-reveal>
          <template v-slot:image>
            <router-link to="/ver/consultasMedicas">
              <v-img :src="require(`@/assets/${'medicos.jpg'}`)" />
            </router-link>
          </template>
          <v-card-title class="justify-center font-weight-light">
            Consultas profesionales
          </v-card-title>
        </base-material-card>
      </v-col>

      <v-col sm="12" md="4">
        <base-material-card color="transparent" image :hover-reveal="tienePermiso('M_pedidos')">
          <template v-slot:image>
            <router-link v-if="$can('M_pedidos')" to="/ver/pedidos">
              <v-img :src="require(`@/assets/${'PedidoJugador.jpg'}`)" />
            </router-link>
            <v-img v-else :src="require(`@/assets/${'PedidoJugador.jpg'}`)" />
          </template>
          <v-card-title class="justify-center font-weight-light">
            Pedidos jugador
          </v-card-title>
        </base-material-card>
      </v-col>
      <v-col sm="12" md="4">
        <base-material-card color="transparent" image :hover-reveal="tienePermiso('M_viaticos')">
          <template v-slot:image>
            <router-link v-if="$can('M_viaticos')" to="ver/viaticos">
              <v-img :src="require(`@/assets/${'Viaticos.png'}`)" />
            </router-link>
            <v-img v-else :src="require(`@/assets/${'Viaticos.png'}`)" />
          </template>
          <v-card-title class="justify-center font-weight-light">
            Viaticos / Indumentaria
          </v-card-title>
        </base-material-card>
      </v-col>

      <v-col sm="12" md="4">
        <base-material-card color="transparent" image :hover-reveal="tienePermiso('M_contratos')">
          <template v-slot:image>
            <router-link v-if="$can('M_contratos')" to="/ver/jugador/lista_contratos">
              <v-img :src="require(`@/assets/${'contratos.jpg'}`)" />
            </router-link>
            <v-img v-else :src="require(`@/assets/${'contratos.jpg'}`)" />
          </template>
          <v-card-title class="justify-center font-weight-light">
            Contratos
          </v-card-title>
        </base-material-card>
      </v-col>

      <v-col sm="12" md="4">
        <base-material-card color="transparent" image :hover-reveal="tienePermiso('M_contratos')">
          <template v-slot:image>
            <router-link v-if="$can('M_contratos')" to="/ver/Vencimientos">
              <v-img :src="require(`@/assets/${'Documentacion.jpg'}`)" />
            </router-link>
            <v-img v-else :src="require(`@/assets/${'Documentacion.jpg'}`)" />
          </template>
          <v-card-title class="justify-center font-weight-light">
            Contratos a vencer
          </v-card-title>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'DashboardDashboard',
    data () {
      return {
      }
    },
    methods: {
      tienePermiso (permiso) {
        return this.$can(permiso)
      },
    },
  }
</script>
